// extracted by mini-css-extract-plugin
var _1 = "CalendarRailSource-moduleappointment__YKNr5";
var _2 = "CalendarRailSource-modulefollowUp__obPGu";
var _3 = "CalendarRailSource-moduletaskDeadline__WuCPS";
var _4 = "CalendarRailSource-moduletitle__fpHjX";
export { _1 as "appointment", _2 as "followUp", _3 as "taskDeadline", _4 as "title" }
